import Head from "next/head";
import { MenuId } from "../../components/Header";
import Layout from "../../components/Layout";
import styles from "./index.module.scss"
import { Accordion, Button, Checkbox, Divider, FocusTrap, Paper, Space, Text, TextInput, Title } from "@mantine/core";
import Link from "next/link";
import { useForm } from '@mantine/form'

import { useState } from "react";

import axios, { AxiosProgressEvent } from "axios";
import { okModal } from "../../lib/utils";
import { modals } from "@mantine/modals";
import { consoleError, setBrowserEmail } from "../../lib/logger";
import React from "react";
import Image from 'next/image';

import imgAandI from './images/a-and-i.png';
import imgCBPP from './images/cbpp.jpg';
import imgLogo from './images/logo.png';
import imgMallGalleries from './images/mall-galleries.png';
import imgRP from './images/the-rp-high-res.jpg';
import imgLizet from './images/lizet.jpg';
import imgStephen from './images/stephen.jpg';
import imgCornelia from './images/cornelia.jpg';

import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import FileChooser, { CompressedFile } from "../../components/FileChooser";



export default function ApplicationForm()
{
    const [uploading, setUploading] = useState(false);

    const [uploadProgress, setUploadProgress] = useState(0);
    const [showUploadProgress, setShowUploadProgress] = useState(false);
    const [phoneNumberError, setPhoneNumberError] = useState(false);

    const [files, setFiles] = useState<CompressedFile[]>([]);
    const[fileError, setFileError] = useState(false);

    const form = useForm({
        initialValues: {firstName:'', lastName: '', email:'',  privacy: false, files:'', subscribeToList:true, confirmLife:false, confirmTravel: false, phoneNumber:'', instagram:'' },
         validate: {
          email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
          files: (value)=>
          {
            if (files.length==0 || files.length>5)
            {
              setFileError(true);
              return "Please use at most 5 files";
            }
            setFileError(false);

            return null;
          },
          phoneNumber: (value)=> 
          { 
            if (value.trim().length<5)
            {
                setPhoneNumberError(true);
                return "Please give a phone number";
            }
            setPhoneNumberError(false);

            return null;
          },




        },
      });

      async function updateUploadProgress (e: AxiosProgressEvent)
      {
          setUploadProgress((e.progress??0)*100);
      }  


      async function submit(values: typeof form.values)
      {

        if (files.length==0)
        {
          return;
        }

        let formData = new FormData();

        Object.keys(form.values).forEach(x=>
          {
            formData.append(x, Object(form.values)[x])
          }
          );
        for (let i =0;i<files.length; i++)
        {
            formData.append("file_" + i, files[i].data);
        }

        setUploadProgress(0);
        setShowUploadProgress(true);
        setUploading(true);

        try
        {
        await axios.post("/n/api/paint-off",
            formData,
            {
                headers:{'Content-Type': 'multipart/form-data'},
                onUploadProgress: updateUploadProgress,
                withCredentials: true
                                  
            });

            await setBrowserEmail(values.email);

            modals.open({
              title: 'Thank you!',
              children: <>
              <Text size="sm">Thank you for submitting your application! We&apos;ll get in touch if we take it to the next stage.</Text>
              <Button fullWidth onClick={(e)=> {modals.closeAll();}} mt="md">
                        Ok
                      </Button>
              </>
      
              
              });

            setShowUploadProgress(false);
        }
        catch(e)
        {
            consoleError(e);
            okModal("There was a problem saving your data. Please email us instead.");
        }
        finally
        {
            setShowUploadProgress(false);
            setUploading(false);
        }

      }

      
      function setPhoneNumber(value: string)
      {
        form.values.phoneNumber = value?value:'';
      }

      function filesUpdated(files: CompressedFile[])
      {
        setFiles(files);
      }

      return(
      <Layout menuId={MenuId.home}>
      <Head>
          <title>Raw Umber Studios Portrait Paint Off 2024</title>
          <meta name='description' content="Join us for a live portrait painting competition. Organised by artists for artists."/>
          <meta property='og:image' content='https://rawumberstudios.com/n/paintoff-1200x630.png'/>
          <meta property='og:image-width' content='1200'/>
          <meta property='og:image-height' content='630'/>
      </Head>
      <Title order={3} mt='xl' ta='center'>
                We&rsquo;re running a live, free to enter, portrait painting competition with £3,500 of prizes in August 2024
                </Title>
      <Text>Entries are now closed! Watch this space ...</Text>
      </Layout>);

    return(
        <Layout menuId={MenuId.home}>
        <Head>
            <title>Raw Umber Studios Portrait Paint Off 2024</title>
            <meta name='description' content="Join us for a live portrait painting competition. Organised by artists for artists."/>
            <meta property='og:image' content='https://rawumberstudios.com/n/paintoff-1200x630.png'/>
            <meta property='og:image-width' content='1200'/>
            <meta property='og:image-height' content='630'/>
        </Head>
            
            <div style={{display:"flex", justifyContent:"center", margin:10}}>
              <h1>
                <Image priority src={imgLogo} width={300} alt='Raw Umber Studios Portrait Paint Off 2024'/>
                </h1></div>
                
            <Title order={3} mt='xl' ta='center'>
                We&rsquo;re running a live, free to enter, portrait painting competition with £3,500 of prizes in August 2024 and <b style={{color:'red'}}>you</b> could be one of the participants.
                </Title>

                <Text mt='lg'>
                  Want to pit your artistic skills against the best of your peers in a live paint-off at a prestigious London location?
                  </Text>
                  
                <Text mt='lg'>
                  On Friday 16th August 2024, ten artists will gather at Mall Galleries in Central London and paint a portrait from life for 4 hours. At the end of the session, a panel of three professional artists (Stephen Bauman, Lizet Dingemans and Cornelia Hernes) will judge the portraits and award a winner. The winner will get a £2,500 cash prize and feature in a future issue of Artists and Illustrators Magazine.
                </Text>

                <Text mt='sm'>
                  In addition, there will be an online, public vote after the event and the winner of that will win a £1,000 cash prize.
                </Text>

                <Text mt='sm'>
                  Entry is open to anybody. To be considered as one of the ten artists, simply fill in your details below and submit an image of a portrait you&rsquo;ve painted from life. The deadline for entrants in 12 noon UK time, 15th May 2024.
                </Text>

<Title order={3} ta="center" mt='lg'>More information and FAQs</Title>
<Accordion multiple>


<Accordion.Item value = 'difference'>
      <Accordion.Control>
        What Makes This Competition Special?
      </Accordion.Control>
      <Accordion.Panel>
      <div className={styles.faq}>
        As artists ourselves, we&rsquo;re running the sort of competition we&rsquo;d like to be part of:
        <ul>
        <li>It&rsquo;s a live painting competition, open to anybody.</li>
        <li>It&rsquo;s run by artists, for artists.</li>
        <li>The 10 entrants, and the ultimate winner, will be chosen solely on artistic merit.</li>
        <li>The judges are professional artists who we admire</li>
        <li>The judges will prioritise accuracy of likeness, technical skill and emotional power in the painting</li>     
        <li>It will feature professional models, with professional lighting.</li>
        <li>You will be working from life - no photographing the model.</li>        
        </ul>
      </div>
      </Accordion.Panel>
  </Accordion.Item>


  <Accordion.Item value = 'entries'>
      <Accordion.Control>
        Entries
      </Accordion.Control>
      <Accordion.Panel>
      <div className={styles.faq}>
        <ul>
        <li>Entries close at 12 noon on <b>15th May 2024</b>. The competion is completely free to enter.</li>
        <li>Note that you may paint in oil paint or acrylics only.</li>     
        </ul>
      </div>
      </Accordion.Panel>
  </Accordion.Item>


  <Accordion.Item value = 'judges'>
      <Accordion.Control>
        The Judges
      </Accordion.Control>
      <Accordion.Panel>
          <div style={{marginBottom:5}}>We have three professional artists as judges. In alphabetical order, they are:</div>
          
          {/* Stephen*/}
          <div style={{display:'flex', flexDirection:'column'}}>
          
            <div className={styles.judge}>
              <div className={styles.judgePhoto}>
              <Image width={250} src={imgStephen} alt="Stephen Bauman"/>
              </div>
            <div className={styles.judgeDescription}>
                <p><b>Stephen Bauman</b> is a classically trained artist and spent 12 years as an instructor in the drawing and painting program of the The Florence Academy of Art. In addition to that he was the director of the Anatomy & Écorché Department for 6 years, first in Sweden and then in the USA.

    In 2020 he left the academy to focus his efforts on his art career and teaching.</p>

    <p>Stephen&rsquo;s Instagram handle is <a href='https://instagram.com/stephenbaumanartwork'>@stephenbaumanartwork</a></p>


            </div>
          </div>
          </div>

<Divider/>

          {/* Lizet*/}
          <div style={{display:'flex', flexDirection:'column'}}>
          
            <div  className={styles.judge}>
              <div className={styles.judgePhoto}>
                <Image width={250} src={imgLizet} alt="Lizet Dingemans"/>
              </div>
            <div className={styles.judgeDescription}>
            <p><b>Lizet Dingemans</b> is Head of Art at Raw Umber Studios. She was born in Helmond, the Netherlands. Unsatisfied with the art education there, she went to Florence in the summer of 2011 to study Fine Art at Angel Academy which gave her the inspiration to continue her art career in London as a student at the London Atelier of Representational Art (LARA).</p>

<p>After graduating she decided to stay, and is now a full-time artist and teacher. Her work has sold in the UK, Germany, the Netherlands and the USA. In 2016 her work was acquired for the MEAM Museum in Barcelona, Spain.</p>

<p>You can find out more about her on Instagram at <a href='https://instagram.com/lizetdingemansartist'>@lizetdingemansartist</a></p>




            </div>
          </div>
          </div>


          <Divider/>

            {/* Cornelia*/}
            <div style={{display:'flex', flexDirection:'column'}}>
          
          <div  className={styles.judge}>
            <div className={styles.judgePhoto}>
            <Image width={250} src={imgCornelia} alt="Cornelia Hernes"/>
            </div>
          <div className={styles.judgeDescription}>
              <p><b>Cornelia Hernes</b> has throughout her career gravitated towards rendering the human form and emotive expressions in the genres of portraiture and mythological motifs. In addition, her still life paintings are recognized for their soulful and atmospheric qualities.</p>

<p>Cornelia earned a Bachelors of Fine Arts from The University of Victoria, BC, Canada in 2003, which exposed her to the paradigms of conceptual art. In the summer months of 2002-2004 she studied with the renowned artist Odd Nerdrum in Norway. 

Following her BFA degree, she pursued a classical realist art education from The Florence Academy of Art in Italy. This pivotal training resonated with her intrinsic interest in classical art. From 2007-2020 Cornelia was a Principal Instructor at the Florence Academy of Art branches in Italy, Sweden and in the USA consecutively.
</p>

<p>You can see her work on Instagram at <a href='https://instagram.com/corneliahernesartwork'>@corneliahernesartwork</a>.</p>

              

          </div>
        </div>


      </div>


      </Accordion.Panel>
  </Accordion.Item>


  <Accordion.Item value = 'dates'>
      <Accordion.Control>
        Dates
      </Accordion.Control>
      <Accordion.Panel>
      <div className={styles.faq}>
        Entries close at 12 noon UK time on <b>15th May 2024</b>. The 10 participants will be notified on <b>22nd May 2024</b>. The competition itself will be held on <b>16th August 2024</b>, from 10am - 5pm.
      </div>      
      </Accordion.Panel>
  </Accordion.Item>

  
  <Accordion.Item value = 'venue'>
      <Accordion.Control>
        The Venue
      </Accordion.Control>
      <Accordion.Panel>
      <div className={styles.faq}>
        The competition is being held at <a href='https://www.mallgalleries.co.uk'>Mall Galleries</a>, in Central London. There are <a href='https://www.mallgalleries.org.uk/your-visit/how-get-mall-galleries'>directions</a> on their website.
      </div>      
      </Accordion.Panel>
  </Accordion.Item>

  <Accordion.Item value = 'day'>
      <Accordion.Control>
        Competition Day
      </Accordion.Control>
      <Accordion.Panel>
      <div className={styles.faq}>
        <div className={styles.answer}>On the day, all ten artists will paint a model from life for 4 hours. There will be two models, so 5 artists per model, and the models will be professionally lit. The day will start at 10am and finish by 5pm.</div>
      </div>
      </Accordion.Panel>
  </Accordion.Item>
  
  
  <Accordion.Item value = 'misc'>
      <Accordion.Control>
        Other Important Information
      </Accordion.Control>
      <Accordion.Panel>
      <div className={styles.faq}>
       <ul>
        <li>
         On the day, you will be painting from life. This presents its own advantages and challenges. For this reason, you will not be allowed to photograph the model.
         </li>
         <li>
         We will be filming the competition day, so you might appear on YouTube, social media etc.
         </li>
         <li>
          For a full list of terms and conditions, see <Link href='./terms'>here</Link>.
         </li>
         </ul>
      </div>
      </Accordion.Panel>
  </Accordion.Item>
  

</Accordion>
<Space h='lg'/>

<Title order={3} ta='center'>Enter now!</Title>


<Text mt='sm' mb='sm'>
                  To enter, simply fill in your details below and submit an image of a portrait you&rsquo;ve painted from life. The deadline for entrants is 12 noon, 15th May 2024.
                </Text>

<Paper>
<FocusTrap active={true}>
          <form onSubmit={form.onSubmit( (values)=> submit(values))}>                            
              <TextInput label="First name" style={{maxWidth:'400px'}} type="text" required {...form.getInputProps('firstName')}/>
              <TextInput label="Last name" style={{maxWidth:'400px'}} type="text" required {...form.getInputProps('lastName')}/>
              <TextInput label="Email address" style={{maxWidth:'400px'}} type="email" required {...form.getInputProps('email')}/>
              <TextInput label="Instagram / website" style={{maxWidth:'400px'}} type="text"  {...form.getInputProps('instagram')}/>

              <Text size='sm' fw={500}>Phone number</Text>
<PhoneInput
country='gb'
value={form.values.phoneNumber}
onChange={phone => setPhoneNumber(phone)}
preferredCountries={['gb']}

/>

{phoneNumberError && <Text c='red' size='xs' >Please enter a phone number</Text>}

<Text size='sm' fw={500}>By completing this application form, you agree to the following:</Text>
<Checkbox required mt='xs' label={<>I have read and agreed with the <Link href='/privacy-policy'>privacy policy</Link>, and competition <Link href='/paint-off-competition-terms-and-conditions'>terms and conditions</Link></>} {...form.getInputProps('privacy')}/>
<Checkbox required mt='xs' label={<>My submission is a portrait I have painted from life</>} {...form.getInputProps('confirmLife')}/>
<Checkbox required mt='xs' label={<>If selected, I can travel to London for August 16th, 2024</>} {...form.getInputProps('confirmTravel')}/>
<Checkbox  mt='xs' label={<>Please add me to the Raw Umber Studios mailing list</>} {...form.getInputProps('subscribeToList', { type: "checkbox" })}/>

<Space h='lg'/>
<Text size='sm' fw={500}>Please upload images of a single portrait you have painted from life:</Text>

<FileChooser maxFiles={5} uploadProgress={uploadProgress} uploading={uploading} filesUpdated={filesUpdated}/>

    {fileError && <Text c='red' size='xs' >Please upload between 1 and 5 files</Text>}

              <Button disabled={uploading} type='submit' mt='sm'>Submit</Button>
                             
            </form>            
            </FocusTrap>
            </Paper>
<Space h='xl'/>

<Title order={3} mb='sm' ta="center">We&rsquo;d like to thank our supporters. In alphabetical order, they are:</Title>

<div style={{display:'flex', flexDirection:'row', flexWrap:'wrap', justifyContent:'center'}}>
    <div className={styles.logo}><a href='https://www.artistsandillustrators.co.uk/' target='_blank'><Image src={imgAandI} width={250} alt='Artists & Illustrators Logo'/></a></div>
    <div className={styles.logo}><a href='https://www.thecbpp.org' target='_blank'><Image src={imgCBPP} width={250} alt='CBPP Logo'/></a></div>
    <div className={styles.logo}><a href='https://www.mallgalleries.org.uk' target='_blank'><Image src={imgMallGalleries} width={250} alt='Mall Galleries Logo'/></a></div>
    <div className={styles.logo}><a href='https://therp.co.uk/' target='_blank'><Image src={imgRP} width={250} alt='The RP Logo'/></a></div>
</div>

           
            </Layout>
    );
}

